<template>
  <div class="weeklyReportPost">
    <div class="pageTitle">
      <p>填写</p>
      <div style="float:right">
        <currentDate @pageReadyFunc="pageReadyFunc"></currentDate>
      </div>
    </div>
    <div class="timeSelectQuery">
      <div class="timeBox">
        <el-select v-model="searchWeekList.year" @change="changeYearOrMonth('year')" placeholder>
          <el-option v-for="item in yearList" :key="item.id" :label="item.Name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="timeBox">
        <el-select v-model="searchWeekList.month" @change="changeYearOrMonth('month')" placeholder>
          <el-option v-for="item in monthList" :key="item.id" :label="item.Name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div
        class="timeBox"
        style="margin-right: 30px;"
        v-for="item in currentMonthInfo.weekList"
        :key="item.weekOfYear">
        <div :class="{'weekTab_active':item.currentWeek}">
          <el-button type="text" @click="changeWeek(item)">{{item.monday|weekDateShow(item.sunday)}}</el-button>
        </div>
      </div>
    </div>

    <div v-if="showNotAllowPostMessage" class="weeklyBox" style="color:red">
        已经超过允许填写本周周报的时间限制。
    </div>

     <div class="weeklyBox">
        <el-row :gutter="20">
          <el-col :span="18">
             <p style="font-size: 14px;margin-bottom: 20px;font-weight: 600;">一周工作小结</p>
            <el-input type="textarea" :rows="5" v-model="weeklyReportData.description"></el-input>
          </el-col>
          <el-col :span="6">
            <p style="font-size: 14px;margin-bottom: 20px;font-weight: 600;">附件（上传后点击提交按钮保存）</p>
            <el-upload
              class="upload-demo"
              :action="uploadApi"
              :on-preview="uploadOnPreview"
              :on-success="uploadOnSuccess"
              :on-remove="uploadOnRemove"
              multiple
              :file-list="weeklyReportData.attachedFiles"
              :headers="{
                Token: this.$userContext.getToken()
              }"
              >
              <el-button size="small" type="primary">上传</el-button>
            </el-upload>
          </el-col>
        </el-row>
      </div>
    <div>
      <el-tabs v-model="currentTabName" @tab-click="tabClick">
        <el-tab-pane
          label="详情视图"
          name="weeklyReportDetailViewTab">
          <post_Detail
            ref="post_Detail"
            :taskList="taskList"
            :currentWeekInfo="currentWeekItem"
            :getWeeklyReportByUserArgs="getWeeklyReportByUserArgs"></post_Detail>
        </el-tab-pane>
        <el-tab-pane
          label="工时视图"
          name="weeklyReportSpentTimeViewTab">
          <post_SpentTime
            ref="post_SpentTime"
            :taskList="taskList"
            :currentWeekInfo="currentWeekItem"
            :getWeeklyReportByUserArgs="getWeeklyReportByUserArgs"></post_SpentTime>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-button v-if="allowPost" type="primary" round @click="post" class="submitBn">提交</el-button>
  </div>
</template>
<script>
import { dateFtt } from "@/utils/auth.js";
import currentDate from "../common/currentDate";
import post_Detail from "./post_Detail";
import post_SpentTime from "./post_SpentTime";
export default {
  name: "weeklyReport",
  components: {
    post_Detail,
    post_SpentTime,
    currentDate
  },
  data() {
    return {
      allowPost:false,
      showNotAllowPostMessage:false,
      settings:this.$userContext.getSettings(),
      uploadApi:window.Glob.BASE_URL + "/api/File/Upload",
      // 记录每周周报的id和备注信息
      weeklyReportData: {
        id: "",
        description: "",
        attachedFiles:[]
      },
      yearList: [],
      //当前月份的周次信息
      currentMonthInfo: {},
      //当前日期和周次
      currentWeekInfo: {
        currentWeekOfYear: "",
        nowDate: ""
      },
      monthList: [
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
        { id: "4", name: "4" },
        { id: "5", name: "5" },
        { id: "6", name: "6" },
        { id: "7", name: "7" },
        { id: "8", name: "8" },
        { id: "9", name: "9" },
        { id: "10", name: "10" },
        { id: "11", name: "11" },
        { id: "12", name: "12" }
      ],
      searchWeekList: {
        year: "",
        month: ""
      },
      //周次列表
      weekList: [],
      lastTabName:"",
      currentTabName: "weeklyReportDetailViewTab",
      currentWeekItem: {}, //传入子组件当前周次信息，用来计算当前周次的日期
      //记录当前选择的周次和年份信息
      getWeeklyReportByUserArgs: {
        userId: this.$userContext.getUserId(),
        year: "",
        month: "",
        weekOfYear: ""
      },
      taskList: [],
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 1000,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {

        }
      }
    };
  },
  filters: {
    weekDateShow: function(monday, sunday) {
      return dateFtt("MM/dd", monday) + " - " + dateFtt("MM/dd", sunday);
    }
  },
  mounted() {
    
  },
  methods: {
    // 获取当前日期后的回调
    pageReadyFunc(currentWeekInfo) {
      this.currentWeekInfo = currentWeekInfo;
      this.searchWeekList.year = new Date(this.currentWeekInfo.now).getFullYear();
      this.searchWeekList.month = new Date(this.currentWeekInfo.now).getMonth() + 1;
      //月份的数组不能超过当前月
      // this.monthList = this.monthList.slice(
      //   0,
      //   new Date(this.currentWeekInfo.now).getMonth() + 1
      // );
      
      //this.getWeekListOfMonth(this.searchWeekList);
      this.getYearList();
      this.changeYearOrMonth();
      this.getTaskList();
    },
    // Tab切换
    tabClick(targetTab) 
    {
      if(this.lastTabName == targetTab.name){
        return;
      }

      this.lastTabName = targetTab.name;

      // 这里的 copyData 深拷贝是为了解决：
      // 当在视图上直接填写，再切 tab ，会造成 vue 对象不更新视图
      // 推测 vue 中对象已经绑定过一个视图了，再切过来绑定新的视图，同时绑定到两个视图，则后者无效。
      if (targetTab.name == "weeklyReportDetailViewTab") 
      {
         let weeklyReportSpentTimeForm = this.$refs.post_SpentTime.convertViewDataToServerData();
         let copyData = JSON.parse(JSON.stringify(weeklyReportSpentTimeForm));
         this.$refs.post_Detail.loadWeeklyReportData(copyData);
      } 
      else if (targetTab.name == "weeklyReportSpentTimeViewTab") 
      {
         // this.timeAddfommateFunc(this.weeklyReportForm);
          let weeklyReportDetailForm = this.$refs.post_Detail.convertViewDataToServerData();
          let copyData = JSON.parse(JSON.stringify(weeklyReportDetailForm));
          this.$refs.post_SpentTime.loadWeeklyReportData(copyData);
      }
    },
    updatePostCondition(){

      this.showNotAllowPostMessage = false;

      if(this.settings!=null && this.settings.weeklyReportPostCondition != 0)
      {
          this.allowPost = false;

          this.$weeklyReportApi.getWeeklyReportPostConditionResult(
            this.searchWeekList.year,this.currentWeekItem.weekOfYear).then(res => 
          {
            if (res.data.successful) 
            {
              this.allowPost = res.data.data;

               this.showNotAllowPostMessage = !this.allowPost;
            }
            else 
            {
              this.$alert(res.data.message, "提示");
            }
          });
      }
      else
      {
         this.allowPost = true;
      }
    },
    //获取年月时间，用于下拉框赋值
    getYearList() {
      this.$dateTimeHelperApi.getYearList().then(res => 
      {
        if (res.data.successful) 
        {
          this.yearList = [];
          let list = res.data.data;
          list.forEach(item => 
          {
            this.yearList.push({ id: item, name: item });
          });
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    // 获取当前月份的周次
    getWeekListOfMonth(data) {
      this.$dateTimeHelperApi.getWeekListOfMonth(data).then(res => 
      {
        if (res.data.successful) 
        {
          this.currentMonthInfo = res.data.data;
          let isCurrentWeek = false;
          let weekOfYear = ""; //取哪周的周报，如果有当前周取当前，没有，取当月的第一周
          this.currentMonthInfo.weekList.forEach(item => 
          {
            // if (isCurrentWeek) return;//如果取到当前周次，后面的周次不再取
            if (item.currentWeek == true) 
            {
              isCurrentWeek = true;
              this.currentWeekItem = item;
              weekOfYear = item.weekOfYear;
            }
          });
          if (!isCurrentWeek) 
          {
            weekOfYear = this.currentMonthInfo.weekList[0].weekOfYear;
            this.currentWeekItem = this.currentMonthInfo.weekList[0];
            this.currentMonthInfo.weekList[0].currentWeek = true;
          }
          let getWeeklyReportByUserArgs = 
          {
            year: this.searchWeekList.year,
            month: this.searchWeekList.month,
            weekOfYear: weekOfYear
          };
          this.getWeeklyReport(getWeeklyReportByUserArgs);
        }
      });
    },

    // 点击周 获取周报信息
    changeWeek(weekItem) 
    {
      this.currentMonthInfo.weekList.forEach(val => 
      {
        val.currentWeek = false;
      });
      weekItem.currentWeek = true;
      this.currentWeekItem = weekItem;
      let args = 
      {
        year: this.searchWeekList.year,
        month: this.searchWeekList.month,
        weekOfYear: weekItem.weekOfYear
      };
      this.getWeeklyReport(args);
    },

    //年月change
    changeYearOrMonth(type) {
      //切换年之后，要刷新月份列表
      this.monthList = [];
      var remoteYear = new Date(this.currentWeekInfo.now).getFullYear();
      var remoteMonth = new Date(this.currentWeekInfo.now).getMonth() + 1;
      var i =0;
      if(remoteYear == this.searchWeekList.year){
        //月份的数组不能超过当前月
        for(i = 1;i<=remoteMonth;i++){
          this.monthList.push({ id: i, name: i });
        }
        // 切换年份，如果年份切换到当前年，月份指定到当前月
        if(type == 'year'){
          this.searchWeekList.month = remoteMonth;
        }
        
      }
      else{
        for(i = 1;i<=12;i++){
          this.monthList.push({ id: i, name: i });
        }
      }
      
      this.getWeekListOfMonth(this.searchWeekList);
    },
    //获取日常工作
    getTaskList() {
      this.$taskApi.getTaskList(this.listQuery).then(res => {
        if (res.data.successful) {
          this.taskList = res.data.data.data;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    //获取周报信息
    getWeeklyReport(args) {
      this.getWeeklyReportByUserArgs.year = args.year;
      this.getWeeklyReportByUserArgs.month = args.month;
      this.getWeeklyReportByUserArgs.weekOfYear = args.weekOfYear;
     
      this.$weeklyReportApi.getWeeklyReportByUser(this.getWeeklyReportByUserArgs)
        .then(res => 
        {
          if (res.data.successful) 
          {
            let data = res.data.data;
            if (data == null) {
              this.weeklyReportData.id = "";
              this.weeklyReportData.description = "";
              this.weeklyReportData.attachedFiles = [];
            } 
            else 
            {
              this.weeklyReportData.id = data.id;
              this.weeklyReportData.description = data.description;
              this.weeklyReportData.attachedFiles = data.attachedFiles;
            }
            
            if(this.$refs.post_Detail!=null)
            {
              this.$refs.post_Detail.loadWeeklyReportData(data);
            }
            if(this.$refs.post_SpentTime!=null)
            {
              this.$refs.post_SpentTime.loadWeeklyReportData(data);
            }
          }
        });


        this.updatePostCondition();
    },

    //提交
    post() {
      
      //数据验证
      let validateResult = true;
      if (this.currentTabName == "weeklyReportDetailViewTab") 
      {
        validateResult = this.$refs.post_Detail.validate();
      } 
      else if (this.currentTabName == "weeklyReportSpentTimeViewTab") 
      {
        validateResult = this.$refs.post_SpentTime.validate();
      }

      if (!validateResult) {
        this.$alert(
          "请检查是否有项目或者日常工作未选择，请完善项目类型或日常工作后再次点击提交按钮",
          "提示"
        );
        return;
      }

      //格式转化
      let serverData;
      if (this.currentTabName == "weeklyReportDetailViewTab") 
      {
        serverData = this.$refs.post_Detail.convertViewDataToServerData();
      } 
      else if (this.currentTabName == "weeklyReportSpentTimeViewTab") 
      {
        serverData = this.$refs.post_SpentTime.convertViewDataToServerData();
      }

      if (this.weeklyReportData.id) {
        serverData.id = this.weeklyReportData.id;
      }

      serverData.description = this.weeklyReportData.description;
      serverData.attachedFiles = this.weeklyReportData.attachedFiles;

      //提交数据
      this.$weeklyReportApi.post(serverData).then(res => {
        if (res.data.successful) {
          this.$message({
            message: "提交成功",
            type: "success",
            customClass: "successMsg",
            duration: 2000
          });
          
          this.weeklyReportData.id = res.data.data;

        } 
        else 
        {
          this.$alert(res.data.message, "提示");
        }
      });
    },

    //附件上传
    uploadOnSuccess(response, file, fileList){
        //console.log(response);
        //console.log(file);
        //console.log(fileList);
        if (response.successful) 
        {
          this.weeklyReportData.attachedFiles.push(response.data.resultItemList[0]);
        }
        else 
        {
          this.$alert(response.message, "提示");
        }
    },

    uploadOnRemove(file, fileList) {
       // console.log(file, fileList);

       for (var i = 0; i < this.weeklyReportData.attachedFiles.length; i++) { 
          if(this.weeklyReportData.attachedFiles[i].url == file.url)
          {
            this.weeklyReportData.attachedFiles.splice(i,1);

              //直接删除有个问题，周报不提交保存。
              // this.$fileApi.remove(file.url).then(res => {
              //   if (res.data.successful) {
                 
              //   } else {
              //     this.$alert(res.data.message, "提示");
              //   }
              // });

            return;
          }
        }
    },
    
     uploadOnPreview(file) {
      //  console.log(file);
        window.open(window.Glob.BASE_URL + file.url); 
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.timeSelectQuery {
  width: 100%;
  height: 55px;
  margin-bottom: 20px;
  margin-top: 40px;
  background: linear-gradient(#f3f3f3, #ffffff 19%, #ffffff 84%, #f3f3f3 100%);
}
.timeBox {
  display: inline-block;
  margin-left: 10px;
  width: auto;
  height: 55px;
  line-height: 55px;
  font-size: 13px;
}
.weekTab_active {
  background-color: #ffa64d;
  padding-left: 15px;
  padding-right: 15px;
}
.weekTab_active .el-button.el-button--text {
  color: #fff !important;
}

.weeklyBox {
  margin-top: 15px;
  margin-bottom: 10px;
  padding: 10px;
  padding-right: 0;
  // box-shadow: 0px 0px 0px 2px #f5f5f5;
  // box-shadow: inset 0px 0px 0px 4px #f5f5f5;
}

</style>


<style  rel="stylesheet/scss" lang="scss">
.weeklyReportPost {

  padding-bottom: 60px;

  .timeBox 
  {
    .el-select 
    {
      width: 100px;
    }
    .el-input--suffix .el-input__inner 
    {
      border: none !important;
      border-radius: 0 !important;
      font-size: 16px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/weeklyReport/post.vue